export default __webpack_public_path__ + "static/media/PAFI_LKTT 2022.7771d854.pdf";